const PROD_API_BASE = 'https://api.membersyncpro.com';
let _baseUrl = null;
let _app = 'web_dashboard';
function readViteEnv() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-new-func
        const meta = new Function('try { return import.meta } catch (_) { return undefined }')();
        const v = meta?.env?.VITE_API_BASE_URL;
        if (typeof v === 'string' && v.length)
            return v.replace(/\/+$/, '');
    }
    catch { /* not Vite */ }
    return null;
}
export function getApiBase() {
    return _baseUrl ?? readViteEnv() ?? PROD_API_BASE;
}
export function configureFeedback(opts) {
    if (opts.baseUrl)
        _baseUrl = opts.baseUrl.replace(/\/+$/, '');
    if (opts.app)
        _app = opts.app;
}
export async function submitFeedback(payload, opts) {
    const body = { ...payload, app: payload.app ?? _app };
    const headers = { 'Content-Type': 'application/json' };
    if (opts?.bearerToken)
        headers.Authorization = `Bearer ${opts.bearerToken}`;
    const res = await fetch(`${getApiBase()}/v1/feedback`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        const err = (await res.json().catch(() => ({})));
        throw new Error(typeof err.error === 'string' ? err.error : `HTTP ${res.status}`);
    }
    return (await res.json());
}
/**
 * Upload an attachment (image File or Blob) and get back the server-side
 * id + URL. Caller passes the returned id(s) into submitFeedback's
 * `attachments` array.
 */
export async function uploadAttachment(file, opts = {}) {
    const form = new FormData();
    // Some Blob subclasses don't carry a name; FormData needs one for multer.
    const filename = opts.filename ?? (file instanceof File ? file.name : 'attachment.png');
    form.append('file', file, filename);
    form.append('kind', opts.kind ?? 'attached');
    const headers = {};
    if (opts.bearerToken)
        headers.Authorization = `Bearer ${opts.bearerToken}`;
    const res = await fetch(`${getApiBase()}/v1/feedback/upload`, {
        method: 'POST',
        headers,
        body: form,
    });
    if (!res.ok) {
        const err = (await res.json().catch(() => ({})));
        throw new Error(typeof err.error === 'string' ? err.error : `HTTP ${res.status}`);
    }
    return (await res.json());
}
export function getBrowserMetadata() {
    if (typeof window === 'undefined')
        return {};
    const loc = window.location;
    return {
        href: loc.href,
        pathname: loc.pathname,
        search: loc.search || undefined,
        hash: loc.hash || undefined,
        title: document.title || undefined,
        userAgent: navigator.userAgent,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        devicePixelRatio: window.devicePixelRatio,
        language: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        referrer: document.referrer || undefined,
        submittedAt: new Date().toISOString(),
    };
}
//# sourceMappingURL=client.js.map